// extracted by mini-css-extract-plugin
export default {"formButtonSubmit":"ScreenStylesForm_formButtonSubmit__XGIQ6"};